var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.3334H14.6666C11.3529 13.3334 8.66663 16.0197 8.66663 19.3334V19.3334C8.66663 20.9247 9.29877 22.4508 10.424 23.576C11.5492 24.7012 13.0753 25.3334 14.6666 25.3334H22C25.3137 25.3334 28 22.6471 28 19.3334V19.3334C27.9976 18.0698 27.5932 16.8398 26.8453 15.8214",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6667H17.3333C20.647 18.6667 23.3333 15.9804 23.3333 12.6667V12.6667C23.3333 9.35298 20.647 6.66669 17.3333 6.66669H10C6.68629 6.66669 4 9.35298 4 12.6667H4C4.00236 13.9302 4.40676 15.1603 5.15467 16.1787",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink2);
export default ForwardRef;